import React, { useEffect } from "react";
import { Table } from "antd";
import { ColumnsType } from "antd/es/table";
import { useSaleListModel } from "../saleListModel";
import { ISaleListDetail } from "../saleListService";
import useNavModel from "@/model/navModel";
import { useSalesDetailModel } from "@/views/sales/view/details/salesDetailModel";
import { formatNum } from "@/utils/utils";
import moment from "moment";

export function DataTable() {
    const {
        dataSource, pgCfg, loading,
        loadData
    } = useSaleListModel();
    const { replaceNav } = useNavModel(() => []);
    const { updateFormVal } = useSalesDetailModel(() => []);


    useEffect(() => {
        loadData()
    }, [])

    const columns: ColumnsType<ISaleListDetail> = [
        {
            title: '序号',
            width: 60,
            align: "center",
            fixed: "left",
            dataIndex: "totalTxt",
            render: (t: any, r: any, i: number) => <>{t ? t : i + 1}</>
        }, {
            title: '外贸合同号',
            width: 160,
            dataIndex: 'realCode',
            fixed: "left",
            ellipsis: true,
            render: (t, r) => <span className="label-span" onClick={() => { updateFormVal("edit", null); t && replaceNav("6-4", "3-2", { id: r.code, mode: "edit" }, true) }}>{t}</span>
        }, {
            title: '业务员',
            width: 100,
            dataIndex: 'createUser',
        }, {
            title: '客户名称',
            width: 160,
            dataIndex: 'customerName',
            ellipsis: true,
        }, {
            title: '贸易国别',
            width: 160,
            dataIndex: 'countryName',
        }, {
            title: '币种',
            width: 160,
            dataIndex: 'currencyName',
        }, {
            title: '签订时间',
            width: 160,
            dataIndex: "offerTime",
            render: t => t ? moment(t).format('YYYY-MM-DD') : ''
        }, {
            title: '外贸合同总金额',
            width: 120,
            dataIndex: "contractAmount",
            render: (t, r) => `${r.currency}${formatNum(t)}`
        }, {
            title: '折算汇率',
            width: 100,
            dataIndex: 'exchangeRate',
        }, {
            title: '外贸合同金额（RMB)',
            width: 120,
            dataIndex: 'gtmAmount',
            render: (t, r) => `${r.currency}${formatNum(t)}`
        }, {
            title: '海运费',
            width: 120,
            dataIndex: 'oceanFreight',
            render: (t, r) => `${r.currency}${formatNum(t)}`
        }
    ];

    return (
        <Table
            rowKey={record => record.id}
            loading={loading}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ["bottomCenter"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                }
            }}
            scroll={{ x: 'max-content', y: "calc(100vh - 360px)" }}
        />
    )
}
